import { API_ROUTES } from "@shared/contracts";

/**
 * The entity's endpoint roots — what the entity's api/ hooks pass as
 * `serviceName` to the CRUD hooks. Always derived from `API_ROUTES`, never
 * hand-written path strings.
 *
 * This backend exposes no `users` resource: registration and the current-user
 * lookup both live on the auth controller, and there is no user list or
 * user-by-id endpoint.
 */
export const USER_REGISTER_SERVICE_NAME = API_ROUTES.AUTH.register();

export const CURRENT_USER_SERVICE_NAME = API_ROUTES.AUTH.me();
